import type { OriginJunctionCriteriaPayload } from "../../../hooks/react-query/backOffice/transitTimesAndServiceLevels/useAddOriginJunction";

export const mockDestinationJunctionCriteria: OriginJunctionCriteriaPayload = {
  groups: [
    {
      id: "mock-dj-criteria-group-1",
      sequences: [
        {
          id: "mock-dj-criteria-seq-1",
          startTableName: "SHIPMENT",
          endTableName: "ZONE",
          startFieldName: "APPT_REQUIRED",
          endFieldName: "ZONE_CODE",
          startLookup: "COLLECT_BILL",
          endLookup: "ZONE_CODE",
          startLogic: "!=",
          endLogic: ">=",
          logicValue: "not like",
          startMin: "CA, OR, WA",
          startMax: "CA, OR, WA",
          endMin: "CA, OR, WA",
          endMax: "CA, OR, WA",
          reverseRange: true,
        },
      ],
    },
    {
      id: "mock-dj-criteria-group-2",
      sequences: [
        {
          id: "mock-dj-criteria-seq-2",
          startTableName: "SHIPMENT",
          endTableName: "ZONE",
          startFieldName: "APPT_REQUIRED",
          endFieldName: "ZONE_CODE",
          startLookup: "COLLECT_BILL",
          endLookup: "ZONE_CODE",
          startLogic: "!=",
          endLogic: ">=",
          logicValue: "not like",
          startMin: "CA, OR, WA",
          startMax: "CA, OR, WA",
          endMin: "CA, OR, WA",
          endMax: "CA, OR, WA",
          reverseRange: true,
        },
      ],
    },
  ],
  betweenGroupLogic: ["AND"],
};

/** API response format for destination junctions (pagination support). */
export const mockEolDestinationJunctionsLinehaulApiRows = [
  {
    id: 117,
    sequence: 1,
    type: "destination",
    junctionCode: "DAL",
    hasCriteria: true,
    serviceLevels: ["LTL", "LTL-CC", "TRUCKLOAD", "VOLUME"],
    additionalDays: 0,
    status: "Active",
    effectiveDate: "01/01/2026",
    expiryDate: "12/31/2026",
    adjIndicator: true,
    carrierCode: null,
    criteriaPayload: mockDestinationJunctionCriteria,
  },
  {
    id: 160,
    sequence: 2,
    type: "destination",
    junctionCode: "HOU",
    hasCriteria: false,
    serviceLevels: ["LTL"],
    additionalDays: 3,
    status: "Inactive",
    effectiveDate: "01/01/2023",
    expiryDate: "12/31/2099",
    adjIndicator: false,
    carrierCode: null,
  },
  {
    id: 161,
    sequence: 3,
    type: "destination",
    junctionCode: "ATL",
    hasCriteria: false,
    serviceLevels: ["LTL"],
    additionalDays: 0,
    status: "Active",
    effectiveDate: "01/01/2023",
    expiryDate: "12/31/2099",
    adjIndicator: true,
    carrierCode: null,
  },
  {
    id: 162,
    sequence: 4,
    type: "destination",
    junctionCode: "DFW",
    hasCriteria: false,
    serviceLevels: ["LTL", "LTL-CC"],
    additionalDays: 1,
    status: "Pending",
    effectiveDate: "01/01/2023",
    expiryDate: "12/31/2099",
    adjIndicator: false,
    carrierCode: null,
  },
];
